module.exports = __webpack_public_path__ + "static/Unify-2-light-e431bac660dec13d8451ea99439527b3.svg";